import { Configuration, LogLevel } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "common";

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    supportsNestedAppAuth: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error("[MSAL]", message);
        }
      },
    },
  },
};

// Scopes for the Office SSO token
export const loginScopes = {
  scopes: [
    `api://${import.meta.env.VITE_ADDIN_URL?.replace("https://", "")}/${clientId}/access_as_user`,
  ],
};

// Scopes for Microsoft Graph (if needed for additional context)
export const graphScopes = {
  scopes: ["User.Read", "Mail.Read"],
};
